<script setup>
const model = defineModel({type: Number});
const props = defineProps({
    min: Number,
    max: Number,
});

function inc(val, amount) {
    let value = (val || 0) + amount;
    if (props.min !== undefined && value < props.min) {
        value = props.min;
    }
    if (props.max !== undefined && value > props.max) {
        value = props.max;
    }
    return value;
}

function isEnabled(amount) {
    if (props.min !== undefined && (model.value || 0) + amount < props.min) {
        return false;
    }
    if (props.max !== undefined && (model.value || 0) + amount > props.max) {
        return false;
    }
    return true;
}
</script>

<template>
    <v-number-input v-model="model" :min="min" :max="max" :step="1" v-bind="$attrs" control-variant="split">
        <template #prepend>
            <v-btn height="100%" :disabled="!isEnabled(-10)" @click="model = inc(model, -10)" class="mr-4">-10</v-btn>
            <v-btn height="100%" :disabled="!isEnabled(-5)" @click="model = inc(model, -5)">-5</v-btn>
        </template>
        <template #append>
            <v-btn height="100%" :disabled="!isEnabled(5)"  @click="model = inc(model, 5)" class="mr-4">+5</v-btn>
            <v-btn height="100%" :disabled="!isEnabled(10)" @click="model = inc(model, 10)">+10</v-btn>
        </template>
    </v-number-input>
</template>
